import React from 'react';
import {Button, Col, Row, Typography} from 'antd';
import _ from 'lodash';

import {getTimeDiff} from '../../../helpers/misc';
import EngageCurrency from '../../../components/billings/EngageCurrency';
import WhiteBackgroundWrapper from '../../../components/WhiteBackgroundWrapper';
import {dayNameDateTimeFormat} from '../../../lib/time';
import {BookingSummaryProps} from '../../../types/bookingTypes';

const {Title, Text} = Typography;

const BookingSummary = ({newBooking, timeCharge, goToBookingSummary, confirmBooking, isBookingLoading}: BookingSummaryProps) => {
    const {startedAt, endedAt, carInfo, locationInfo, bookingType} = newBooking;
    const startTime = startedAt.format(dayNameDateTimeFormat);
    const endTime = endedAt ? endedAt.format(dayNameDateTimeFormat) : 'N/A';
    const duration = getTimeDiff(startedAt, endedAt);

    return (
        <div>
            <Row>
                <Col xs={24}>
                    <Title level={2} className="grid-title">Confirm Booking Details</Title>
                </Col>
            </Row>
            <WhiteBackgroundWrapper>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Return Type:</Text>
                    </Col>
                    <Col xs={24} md={20}>{_.startCase(bookingType)}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Car:</Text>
                    </Col>
                    <Col xs={24} md={20}>{carInfo}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Location:</Text>
                    </Col>
                    <Col xs={24} md={20}>{locationInfo}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Start Time:</Text>
                    </Col>
                    <Col xs={24} md={20}>{startTime}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>End Time:</Text>
                    </Col>
                    <Col xs={24} md={20}>{endTime}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Duration:</Text>
                    </Col>
                    <Col xs={24} md={20}>{duration}</Col>
                </Row>
                {
                    (bookingType === 'open_return')
                    &&
                    <Row>
                        <Col xs={24} md={4}>
                            <Text strong>Open Return Fee: </Text>
                        </Col>
                        <Col xs={24} md={20}>
                            <EngageCurrency amount={3}/>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Time Charge: </Text>
                    </Col>
                    <Col xs={24} md={20}>
                        <EngageCurrency amount={timeCharge}/>
                    </Col>
                </Row>
                <Row justify="end">
                    <Col>
                        <Button
                            style={{marginRight: '10px'}}
                            onClick={goToBookingSummary}
                        >
                            Back
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={confirmBooking}
                            loading={isBookingLoading}
                        >
                            Confirm Booking
                        </Button>
                    </Col>
                </Row>
            </WhiteBackgroundWrapper>
        </div>
    );
}

export default BookingSummary;
